import {alpha, Fab, Fade, useScrollTrigger} from "@mui/material";
import {KeyboardArrowUp} from "@mui/icons-material";
import {FC, ReactElement, useEffect, useState} from "react";
import {useTheme} from "@mui/material/styles";

interface IProps {
    children: ReactElement
}

const ScrollTopContainer: FC<IProps> = (props) => {
    const theme = useTheme()
    const [isFooterVisible, setIsFooterVisible] = useState(false)

    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
        target: window,
        disableHysteresis: true,
        threshold: 100,
    });

    useEffect(() => {
        const footerElement = document.querySelector("footer")
        if (!footerElement || !("IntersectionObserver" in window)) {
            return
        }

        const observer = new IntersectionObserver(
            (entries) => setIsFooterVisible(entries.some((entry) => entry.isIntersecting)),
            {threshold: 0.05}
        )

        observer.observe(footerElement)

        return () => observer.disconnect()
    }, [])

    const handleClick = () => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    };

    return (
        <>
            {props.children}
            <Fade in={trigger}>
                <Fab color="primary" size="small" aria-label="scroll back to top"
                     onClick={handleClick}
                     role="presentation"
                     sx={{
                         position: 'fixed',
                         right: 16,
                         bottom: isFooterVisible
                             ? {xs: 16, md: 84}
                             : 16,
                         color: theme.palette.primary.main,
                         backgroundColor: alpha(theme.palette.primary.main, .16),
                         border: `1px solid ${alpha(theme.palette.primary.main, .42)}`,
                         boxShadow: 1,
                         backdropFilter: "blur(10px)",
                         WebkitBackdropFilter: "blur(10px)",
                         '&:hover': {
                             backgroundColor: alpha(theme.palette.primary.main, .24),
                             boxShadow: 2
                         },
                     }}>
                    <KeyboardArrowUp/>
                </Fab>
            </Fade>
        </>

    );
}

export default ScrollTopContainer
